import manageEmployeeReducer from "./manageEmployeeReducer";
import viewEmployeeReducer from "./viewEmployeeReducer";
import {manageGroupsReducer} from './manageGroupsReducer';
import { addEmployeeReducer } from "./addEmployeeReducer";
import {manageorganizatonReducer} from "./manageorganizatonReducer";
import { customerListReducer } from "./customerListReducer";
import {  combineReducers } from "redux";

const rootReducer = combineReducers({
    mEmRe: manageEmployeeReducer,
    mGrRe: manageGroupsReducer,
    addEmpRed: addEmployeeReducer,
    vEmRe: viewEmployeeReducer,
    mOrgRe:manageorganizatonReducer,
    cLRe: customerListReducer,
})

export default rootReducer;


// WEBPACK FOOTER //
// ./src/reducers/index.js